/* CLD buy box: set choice, tick-box add-ons, a live total and the instant colour switch.
   Ticked add-ons, the set accessory (and the free gift on products that have one) are added to the cart just before the theme's own add-to-cart runs, so the cart
   drawer shows everything.
   The colour switch replaces the whole buy box with the other colour's, so every listener
   here hangs off the document and reads the current 'root', never a saved element. */
(function () {
  var root = document.querySelector('[data-cld-buybox]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var fmt = (window.EOLUX && window.EOLUX.moneyFormat) || '{{amount_with_comma_separator}} €';
  /* 15 Oct 2026: the free gift is made free by Shopify's own automatic discount
     'Regalo: Cepillo Anti-Frizz con tu herramienta' (Buy X Get Y), not by a gift app,
     so it goes in the cart with no hidden tags. */
  /* Set 2 as a Shopify bundle: when the visitor picks dryer + accessory, the bundle product
     goes in the cart instead of the two separate products, at the bundle's own price (no set
     discount needed). Key = 'dryer variant id:accessory variant id', value = bundle variant id.
     Bundles: 'Secador EX02 + Rizador de aire · Bronce' / '· Perla' (259 €). If a bundle is
     re-created or its price changes, update this list and the product's cld.set2_saving. */
  var BUNDLES = {
    '49591381459234:50303348244770': 67528447754530,
    '49591396139298:50303348244770': 67528447721762
  };

  function num(v, dec, th, ds) {
    var p = v.toFixed(dec).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return p.join(ds);
  }
  function money(cents) {
    var v = cents / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return num(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return num(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(v, 0, '.', ',');
      return num(v, 2, ',', '.');
    }).replace(/[.,]00(?!\d)/, '');
  }

  var prices = {};
  function readPrices() {
    try { prices = JSON.parse(root.querySelector('[data-cld-prices]').textContent); } catch (e) { prices = {}; }
  }
  readPrices();

  function boxes() { return root.querySelectorAll('[data-cld-addon]'); }
  function box(handle) { return root.querySelector('[data-cld-addon][data-handle="' + handle + '"]'); }

  /* Sets: 'data-add' puts an accessory in the same order (two separate order lines),
     'data-swap' sends another product to the cart instead of this one (the other product of
     the family, or the set 2 bundle). 'data-mode' says which photos and title to show. */
  function sets() { return root.querySelectorAll('[data-cld-set]'); }
  function currentSet() { return root.querySelector('[data-cld-set]:checked'); }
  function soloSet() { return root.querySelector('[data-cld-set][value="solo"]'); }
  function included(set) {
    if (!set) return [];
    return (set.getAttribute('data-includes') || '').split(',').filter(function (x, k, a) { return x && a.indexOf(x) === k; });
  }
  function idInputs() {
    return document.querySelectorAll('#ProductForm-' + sectionId + ' [data-variant-id], #StickyForm-' + sectionId + ' [data-variant-id]');
  }
  function ownVariant() {
    var i = root.querySelector('form.product-form [data-variant-id]');
    return i ? (i.getAttribute('data-cld-orig') || i.value) : '';
  }
  /* The bundle variant for this set, or 0 when the set has no bundle. */
  function bundleFor(set) {
    var add = set && set.getAttribute('data-add');
    if (!add) return 0;
    var base = set.getAttribute('data-swap') || ownVariant();
    return BUNDLES[base + ':' + add] || 0;
  }
  function swap(set) {
    var to = set ? String(bundleFor(set) || set.getAttribute('data-swap') || '') : '';
    Array.prototype.forEach.call(idInputs(), function (i) {
      if (to) {
        if (i.value !== to) {
          if (!i.getAttribute('data-cld-orig')) i.setAttribute('data-cld-orig', i.value);
          i.value = to;
        }
      } else if (i.getAttribute('data-cld-orig')) {
        i.value = i.getAttribute('data-cld-orig');
        i.removeAttribute('data-cld-orig');
      }
    });
  }
  /* Photos and title follow the set: 'solo' = this product, 'plus' = this product with
     its accessory, 'full' = the other product of the family. */
  function show(mode) {
    if (!root.querySelector('[data-cld-gal="' + mode + '"]')) mode = 'solo';
    var gals = root.querySelectorAll('[data-cld-gal]');
    if (gals.length > 1) {
      Array.prototype.forEach.call(gals, function (g) {
        var hide = g.getAttribute('data-cld-gal') !== mode;
        if (!hide && g.hidden) {
          Array.prototype.forEach.call(g.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
        }
        if (hide) Array.prototype.forEach.call(g.querySelectorAll('video'), function (v) { v.pause(); });
        g.hidden = hide;
      });
    }
    var h = root.querySelector('[data-cld-title]');
    if (h) {
      var t = h.getAttribute('data-' + mode) || h.getAttribute('data-solo');
      if (t && h.textContent !== t) h.textContent = t;
    }
  }
  function modeOf(set) {
    if (!set) return 'solo';
    return set.getAttribute('data-mode') || (set.getAttribute('data-add') ? 'plus' : set.getAttribute('data-swap') ? 'full' : 'solo');
  }

  /* Thumbnails of the set 2 gallery. */
  document.addEventListener('click', function (e) {
    var th = e.target.closest ? e.target.closest('[data-cld-g2-thumb]') : null;
    if (!th || !root.contains(th)) return;
    var g = th.closest('[data-cld-gal]'), main = g && g.querySelector('[data-cld-g2-main]');
    if (!main) return;
    main.removeAttribute('srcset');
    main.src = th.getAttribute('data-src');
    Array.prototype.forEach.call(g.querySelectorAll('[data-cld-g2-thumb]'), function (b) {
      b.classList.toggle('is-on', b === th);
      b.setAttribute('aria-pressed', b === th ? 'true' : 'false');
    });
  });

  /* Moving through the photos of every gallery.
     Desktop: two quiet arrows on the main photo, which fill in when the pointer is over the gallery.
     Mobile: no arrows and no counter; swipe the photo left or right.
     Both press the previous or next thumbnail, so the theme's own gallery keeps doing the work. */
  function arrows() {
    if (!document.getElementById('cld-arrow-css')) {
      var st = document.createElement('style');
      st.id = 'cld-arrow-css';
      st.textContent = '.cld-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:2;width:32px;height:32px;padding:0;border:0;border-radius:50%;background:transparent;color:#0A1B29;opacity:.45;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:opacity .2s,background .2s}' +
        '[data-cld-gal]:hover .cld-arrow,.cld-arrow:focus-visible{opacity:1;background:rgba(255,255,255,.85)}.cld-arrow:hover{background:#fff}' +
        '.cld-arrow--prev{left:8px}.cld-arrow--next{right:8px}.cld-arrow svg{width:13px;height:13px;display:block}' +
        '.cld-g2-main{position:relative}' +
        '@media(max-width:989px){.cld-arrow{display:none}.cld-bb .product-gallery__stage,.cld-g2-main{touch-action:pan-y}}' +
        '.cld-bb .main-product__grid{transition:opacity .15s}.cld-bb.is-swapping .main-product__grid{opacity:.5;pointer-events:none}';
      document.head.appendChild(st);
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-cld-gal]'), function (gal) {
      var theme = gal.querySelector('.product-gallery__stage');
      var stage = theme || gal.querySelector('.cld-g2-main');
      var sel = theme ? '.product-gallery__thumb' : '[data-cld-g2-thumb]';
      var onClass = theme ? 'product-gallery__thumb--active' : 'is-on';
      if (!stage || stage.querySelector('.cld-arrow') || gal.querySelectorAll(sel).length < 2) return;

      function step(dir) {
        var th = gal.querySelectorAll(sel), i = 0;
        Array.prototype.forEach.call(th, function (t, k) { if (t.classList.contains(onClass)) i = k; });
        var next = th[(i + dir + th.length) % th.length];
        next.click();
        /* Keep the active thumbnail in view inside its own strip, without moving the page. */
        var rail = next.parentElement;
        if (rail) {
          rail.scrollTop = next.offsetTop - (rail.clientHeight - next.offsetHeight) / 2;
          rail.scrollLeft = next.offsetLeft - (rail.clientWidth - next.offsetWidth) / 2;
        }
      }

      [-1, 1].forEach(function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cld-arrow cld-arrow--' + (dir < 0 ? 'prev' : 'next');
        b.setAttribute('aria-label', dir < 0 ? 'Foto anterior' : 'Foto siguiente');
        b.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir < 0 ? 'M10 3L5 8l5 5' : 'M6 3l5 5-5 5') + '"/></svg>';
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          step(dir);
        });
        stage.appendChild(b);
      });

      /* Swipe: a mostly horizontal drag of at least 40 px moves one photo. */
      var x0 = null, y0 = 0;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        step(dx < 0 ? 1 : -1);
      }, { passive: true });
    });
  }

  function update() {
    var idInput = root.querySelector('form.product-form [data-variant-id]');
    var origId = idInput && (idInput.getAttribute('data-cld-orig') || idInput.value);
    var base = (origId && prices[origId]) || +root.getAttribute('data-base-price') || 0;
    var set = currentSet(), inc = included(set);
    Array.prototype.forEach.call(sets(), function (r) {
      var c = r.closest('.cld-set');
      if (c) c.classList.toggle('is-on', r.checked);
    });
    swap(set);
    show(modeOf(set));
    var extra = 0, n = 0;
    Array.prototype.forEach.call(boxes(), function (b) {
      var card = b.closest('.cld-addon');
      var inSet = inc.indexOf(b.getAttribute('data-handle')) > -1;
      if (inSet) b.checked = false;
      if (card) { card.hidden = inSet; card.classList.toggle('is-on', b.checked); }
      if (b.checked) { extra += +b.getAttribute('data-price'); n++; }
    });
    var tot = root.querySelector('[data-cld-tot]');
    if (tot) {
      tot.textContent = money((set ? +set.getAttribute('data-total') : base) + extra);
      var sv = root.querySelector('[data-cld-tot-save]'), saved = set ? +set.getAttribute('data-save') : 0;
      if (sv) {
        sv.hidden = !saved;
        var wrap = root.querySelector('[data-cld-sets]');
        sv.textContent = ((wrap && wrap.getAttribute('data-save-label')) || 'Ahorras [x]').replace('[x]', money(saved));
      }
    }
    var row = root.querySelector('[data-cld-total-row]');
    if (row) {
      row.hidden = !n;
      var t = row.querySelector('[data-cld-total]');
      if (t) t.textContent = money(base + extra);
    }
    /* Buttons elsewhere on the page: shown only for accessories this product can add, and
       marked as added when the accessory is ticked or is part of the chosen set. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-cld-add]'), function (btn) {
      var h = btn.getAttribute('data-cld-add'), b = box(h);
      if (!b && !inAnySet(h)) { btn.hidden = true; return; }
      btn.hidden = false;
      var on = (b && b.checked) || inc.indexOf(h) > -1;
      btn.textContent = on ? btn.getAttribute('data-added') : btn.getAttribute('data-label');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function inAnySet(handle) {
    var found = false;
    Array.prototype.forEach.call(sets(), function (r) { if (included(r).indexOf(handle) > -1) found = true; });
    return found;
  }

  document.addEventListener('change', function (e) {
    if (e.target && root.contains(e.target)) update();
  });

  /* Buttons elsewhere on the page (styling guides) add or remove an accessory, and the buy
     box then picks the set that matches everything added so far. Example on the dryer:
     Air Curler alone = the Air Curler set; Air Curler + diffuser = the complete set;
     diffuser alone = the dryer with the diffuser ticked as an add-on. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cld-add]') : null;
    if (!btn) return;
    var h = btn.getAttribute('data-cld-add'), cur = currentSet();
    /* Everything switched on right now: what the chosen set brings, plus ticked add-ons. */
    var want = included(cur).slice();
    Array.prototype.forEach.call(boxes(), function (b) {
      var bh = b.getAttribute('data-handle');
      if (b.checked && want.indexOf(bh) < 0) want.push(bh);
    });
    if (want.indexOf(h) > -1) want = want.filter(function (x) { return x !== h; });
    else want.push(h);
    /* The biggest set that brings only wanted accessories wins. */
    var best = null, bestN = 0;
    Array.prototype.forEach.call(sets(), function (r) {
      var inc = included(r);
      if (!inc.length || inc.length <= bestN) return;
      if (inc.every(function (x) { return want.indexOf(x) > -1; })) { best = r; bestN = inc.length; }
    });
    if (!best) best = (cur && !included(cur).length) ? cur : soloSet();
    if (best) best.checked = true;
    var covered = included(best);
    Array.prototype.forEach.call(boxes(), function (b) {
      var bh = b.getAttribute('data-handle');
      b.checked = want.indexOf(bh) > -1 && covered.indexOf(bh) < 0;
    });
    update();
    /* Tell the page the set changed, so the gallery can open on its chosen photo. */
    if (best && best !== cur) best.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Add ticked add-ons and the gift first, then hand the click back to the theme. */
  var passing = false;
  document.addEventListener('click', function (e) {
    if (passing) return;
    var btn = e.target.closest ? e.target.closest('[data-add-to-cart]') : null;
    if (!btn) return;
    var form = btn.closest('form');
    /* getAttribute: the form has an input named 'id', which hides form.id. */
    var formId = form ? form.getAttribute('id') : '';
    if (formId !== 'ProductForm-' + sectionId && formId !== 'StickyForm-' + sectionId) return;
    var items = [];
    Array.prototype.forEach.call(boxes(), function (b) {
      if (b.checked) items.push({ id: +b.value, quantity: 1 });
    });
    var set = currentSet();
    if (set && set.getAttribute('data-add') && !bundleFor(set)) items.push({ id: +set.getAttribute('data-add'), quantity: 1 });
    var giftId = +root.getAttribute('data-cld-gift') || 0;
    if (!items.length && !giftId) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.setAttribute('aria-busy', 'true');
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* One gift per cart: skip it when it is already there (in any colour). Shopify's own
       automatic discount makes it free and still lets 10EOLUX apply. */
    var ready = !giftId ? Promise.resolve() : fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gp = +root.getAttribute('data-cld-gift-product') || 0;
        var has = (cart.items || []).some(function (i) {
          return i.variant_id === giftId || (gp && i.product_id === gp) || (i.properties && i.properties._bogo_gift);
        });
        if (!has) items.push({ id: giftId, quantity: 1 });
      })
      .catch(function () {});

    ready.then(function () {
      if (!items.length) return;
      return fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).catch(function () {}).then(function () {
      btn.removeAttribute('aria-busy');
      Array.prototype.forEach.call(boxes(), function (b) { b.checked = false; });
      update();
      passing = true;
      btn.click();
      passing = false;
    });
  }, true);

  /* Instant colour switch. Each colour is its own product, so a swatch is a link to another
     page. Instead of loading that page, its buy box is fetched and put in place of this one:
     photos, sets and button change on the spot and the visitor keeps their place.
     The address bar is updated to the colour's own URL. If anything fails, the link simply
     opens as a normal page. */
  var cache = {}, busy = false;
  function sectionUrl(href) {
    var u = new URL(href, location.href);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }
  function load(href) {
    if (!cache[href]) {
      cache[href] = fetch(sectionUrl(href), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('status');
        return r.text();
      });
      cache[href].catch(function () { delete cache[href]; });
    }
    return cache[href];
  }
  function swatch(e) { return e.target.closest ? e.target.closest('[data-cld-color]') : null; }
  /* Start fetching as soon as the pointer or finger reaches a swatch. */
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var a = e.target && e.target.nodeType === 1 ? swatch(e) : null;
      if (a && root.contains(a) && !a.hasAttribute('aria-current') && window.fetch && window.URL) load(a.getAttribute('href'));
    }, { capture: true, passive: true });
  });
  document.addEventListener('click', function (e) {
    var a = swatch(e);
    if (!a || !root.contains(a)) return;
    if (a.hasAttribute('aria-current')) { e.preventDefault(); return; }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
    var wrap = document.getElementById('shopify-section-' + sectionId);
    if (!wrap || !window.fetch || !window.URL || !window.DOMParser || !history.pushState) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    var href = a.getAttribute('href');
    root.classList.add('is-swapping');
    load(href).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + sectionId);
      if (!fresh || !fresh.querySelector('[data-cld-buybox]')) throw new Error('shape');
      wrap.innerHTML = fresh.innerHTML;
      /* Scripts put in with innerHTML do not run: re-create the inline ones. */
      Array.prototype.forEach.call(wrap.querySelectorAll('script'), function (old) {
        if (old.src || (old.type && old.type !== 'text/javascript' && old.type !== 'module')) return;
        var s = document.createElement('script');
        s.textContent = old.textContent;
        old.parentNode.replaceChild(s, old);
      });
      history.pushState({ cldColor: true }, '', href);
      /* The same signal the theme editor sends: the theme and this file both re-start on it. */
      wrap.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionId } }));
      busy = false;
    }).catch(function () {
      location.href = href;
    });
  });
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.cldColor || document.querySelector('[data-cld-buybox]')) location.reload();
  });

  function start() {
    root = document.querySelector('[data-cld-buybox]') || root;
    readPrices();
    update();
    arrows();
  }
  update();
  arrows();
  document.addEventListener('shopify:section:load', start);
})();
